//cn.js
const cn = {
  //公共
  common: {
    notSupport: '您的浏览器不支持全屏模式',
    loadFail: '主题加载失败',
    noPermission: '抱歉，你无权访问该页面',
    backHome: '返回首页',
    noExit: '抱歉，你访问的页面不存在',
    serverError: '抱歉，服务器出错了',
    slide: '向右滑动',
    veryHigh: '极高',
    high: '高',
    target: '目标范围内',
    urgentLow: '极低',
    agpNoData: 'AGP报告需要至少5天数据生成',
    noDataStr: '暂无数据',
    setting: '设置',
    personInfo: '基本信息',
    updatePwd: '更改密码',
    upHead: '上传头像',
    inRange: '在范围内',
    normal: '正常',
    low: '低',
    previous: '前一天',
    next: '后一天',
    search: '搜索',
    reset: '重置',
    cancel: '取消',
    ok: '确认',
    confirm: '确认',
    save: '保存',
    submit: '提交',
    successful: '成功',
    pleaseEnter: '请输入',
    pleaseSelect: '请选择',
    success: '成功',
    confirmLogout: '您确定要退出吗?',
    updateSuccessed: '已更新成功',
    warning: '警告',
    date: '日期',
    start: '开始',
    end: '结束',
    sevenDays: '7天',
    fourteenDays: '14天',
    thirtyDays: '30天',
    signOut: '退出',
    personalInformation: '个人信息',
    email: '电子邮件',
    name: '姓名',
    mobile: '手机',
    dateOfBirth: '出生日期',
    gender: '性别',
    diabeteType: '糖尿病类型',
    dateOfDignose: '诊断年份',
    remarks: '备注',
    optionMale: '男性',
    optionFemale: '女性',
    optionUnknow: '不想说',
    noDiabetes: '没有糖尿病',
    diabeteTypeI: '1型糖尿病',
    diabeteTypeII: '2型糖尿病',
    diabeteSpecial: '特殊的',
    diabeteGestational: '妊娠糖尿病',
    diabeteOthers: '其它',
    ruleMsgEmail: '请输入邮箱',
    ruleMsgName: '请输入姓名',
    ruleMsgMobile: '请输入手机',
    ruleMsgBirthday: '请选择生日',
    ruleMsgSex: '请选择性别',
    ruleMsgDiabeteType: '请选择糖尿病类型',
    ruleMsgDateOfDignose: '请选择诊断年份',
    ruleMsgRemarks: '请输入备注',
    ruleMsgCorrectMobile: '请输入正确的手机号',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    ruleMsgOldPassword: '请输入旧密码',
    ruleMsgNewPassword: '请输入新密码',
    ruleMsgConfirmPassword: '请确认密码',
    passwordInconsistent: '两次密码输入不一致',
    passwordModifySuccessed: '密码修改成功，请重新登录!',
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    sunday: '周日',
    sn: '序列号',
    startDate: '开始时间',
    days: '天',
    pdfDate: '目标',
    close: '关闭',
    inputTip: '请输入关键字搜索',
    polarization: '设备初始化中',
    hour: '小时',
    minutes: '分钟',
    seconds: '秒',
    reportDownLoadTip: '您的报告未满足5天暂未生成',
    age: '岁',
    goal: 'Goal',
    expired: '传感器已过期',
    lastTime: '最后刷新时间',
    timeZone: '时区'
  },
  //路由
  route: {
    login: '登录',
    forget: '忘记密码',
    home: '首页',
    glucoseReport: '葡萄糖报告',
    sessionReport: '轮次报告',
    eventList: '事件列表',
    followerList: '观察者列表',
    followerListQ: '观察者请求',
    settings: '设置',
    profile: '配置'
  },
  //登录
  login: {
    rememberMe: '记住我',
    forgetPassword: '忘记密码',
    agree: '登陆即表示同意',
    privacyPolicy: '隐私政策',
    CGMUser: 'CGM用户',
    follower: '观察者',
    ruleMsgPassword: '请输入密码',
    login: '登陆',
    phonePlacehold: '请输入手机号',
    codePlacehold: '请输入验证码',
    phoneTip: '手机验证码登陆',
    emialTip: '邮箱密码登陆',
    codeTip: '获取验证码',
    reGetTip: '重新获取'
  },
  layout: {
    collapseUp: '收起菜单',
    collapseDown: '展开菜单',
    refresh: '刷新',
    backHome: '回到主页',
    helpCenter: '帮助中心',
    fullScreen: '全屏模式'
  },
  //忘记密码
  forget: {
    ruleMsgCode: '请输入密码',
    sendCode: '发送代码',
    tipsMsgSendSuccess: '验证码发送成功!',
    tipsMsgModifySuccess: '密码修改成功'
  },
  //首页
  home: {
    title: '门户',
    todaysGlucose: '今日葡萄糖',
    todaysOverview: '今日概述',
    maxGlucose: '最高葡萄糖',
    minGlucose: '最低葡萄糖',
    avgGlucose: '平均葡萄糖',
    maxmumVariation: '最大变化速率',
    glucose: '葡萄糖',
    tir: '区间',
    latestGlucose: '最新葡萄糖读数',
    todayPercentage: '今天TIR在不同的范围',
    fourHour: '4小时',
    eightHour: '8小时',
    twelveHour: '12小时',
    twentyFourHour: '24小时',
    glucoseOnly: '只看葡萄糖',
    sessionOverview: '轮次概述',
    glocuseMetrics: '葡萄糖标准',
    agp: 'AGP',
    dailyGlucose: '每日葡萄糖',
    sessionGlucose: '轮次葡萄糖',
    standTir: '标准TIR',
    customTir: '自定义TIR',
    cancleGz: '取消关注',
    cancleText: '是否取消关注当前用户？',
    helpCenterTip: '功能暂未开放'
  },
  //血糖报告
  glucoseReport: {
    statics: '统计',
    sixHour: '6小时TIR',
    avgGlucose: '平均葡萄糖',
    maxGlucose: '最高葡萄糖',
    minGlucose: '最低的葡萄糖',
    cv: '血糖变异系数',
    high: '高血糖事件数',
    low: '低血糖事件数',
    normal: '正常血糖事件数',
    tir: 'TIR',
    estimatedA1c: '预估糖化血红蛋白',
    min: '最小值',
    avg: '平均值',
    max: '最大值',
    maxVariation: '最大变化'
  },
  //血糖档案
  glucoseProfile: {
    avg: '平均',
    sd: '标准差',
    cv: '变异系数'
  },
  //事件列表
  eventList: {
    all: '所有',
    bg: '指血',
    meal: '饮食',
    sport: '运动',
    insulin: '胰岛素',
    alert: '提醒',
    eventType: '事件类型',
    description: '描述',
    note: '注意',
    highAlert: '提醒警告',
    calibration: '校准',
    meds: '药物',
    time: '时间',
    detail: '详情',
    weigt: '体重'
  },
  // 关注列表
  followerList: {
    title: '监测用户',
    tabTitle: '观察者管理',
    refreshText: '自动刷新（用户列表每30s自动刷新）',
    addText: '新增',
    dataText: '数据获取于',
    timeText: '分钟',
    hourText: '小时',
    agoText: '前',
    tableEmail: '输入账号',
    searchPlacehold: '请输入账号进行搜索',
    pending: '等待',
    approved: '批准',
    rejected: '拒绝',
    addFollower: '添加观察者',
    editFollower: '编辑观察者',
    tableName: '名字',
    tableAddTime: '添加时间',
    tableStatus: '状态',
    tableApproved: '批准',
    tableReject: '拒绝',
    tableStartSharing: '开始共享',
    tableStopSharing: '停止共享',
    op: '操作',
    sharing: '共享',
    notSharing: '未共享',
    tableRemove: '删除',
    note: '注意',
    message: '消息',
    ruleMsgEmailEmpty: '请输入邮箱进行搜索',
    ruleMsgNote: '请输入备注',
    ruleMsgMessage: '请留言',
    ruleMsgEmailCorrect: '请输入正确的邮箱',
    formAcknowledge: '我了解添加观察者将允许该用户查看我的数据',
    sendFollowRequest: '发送观察请求',
    setNote: '设置备注',
    tipsAcknowledge: '请点击确认：添加观察者将允许该用户查看我的数据',
    stopSharing: '停止共享',
    startSharing: '开始共享',
    removeUser: '移除用户',
    confirmStopSharing: '您确定停止与该用户共享葡萄糖数据了吗?',
    confirmStartSharing: '您确定要开始与该用户共享葡萄糖数据吗?',
    confirmRemove: '您确定要从列表中移除该用户吗?',
    approvedFollower: '已批准的观察者',
    rejectFollower: '已拒绝的观察者',
    confirmApproved: '你确定批准此观察请求吗?',
    confirmReject: '您确定拒绝此观察请求吗?',
    addTime: '添加时间',
    check: '查看',
    remove: '删除',
    removeUserTitle: '是否确定移除？'
  },
  //设置
  settings: {
    title: '葡萄糖水平设置',
    unitSet: '单位设置',
    targetSet: '自定义TIR区间设置',
    alertSet: '提醒设置',
    highAlert: '高提醒',
    lowAlert: '低提醒',
    urgentLow: '极低',
    urgentHigh: '极高',
    target: '目标'
  },
  // pdf
  pdf: {
    dailyStatistics: '每日统计',
    title: 'AGP报告:持续血糖监测',
    page: '页面',
    generated: '生成',
    lage: '最大血糖波动幅度',
    mage: '平均血糖波动幅度',
    modd: 'MODD',
    range: '血糖目标范围时间',
    timeInRange: '血糖目标范围时间',
    agpTitle: '动态葡萄糖图谱(AGP)',
    agpSubTitle:
      'AGP是报告期间血糖值的总结，中位数(50%)和其他百分位数显示为一天内发生的血糖值的区间',
    dailyTitle: '每日葡萄糖图谱',
    dailySubTitle: '每日图谱代表一个从凌晨到午夜的时间区间',
    device: '设备',
    tDevice: '终端设备',
    print: '打印',
    model: '型号',
    deviceSn: '设备序列号',
    effectiveData: '有效数据率',
    days: '使用天数',
    appVer: '软件版本号',
    smartPhoneModel: '手机型号',
    osVersion: '操作系统号',
    appSetting: '应用设置',
    GoalsforType1andType2Diabetes: '1型和2型糖尿病目标',
    Each1timeinrange15minutes: '范围内的每1%时间=约15分钟',
    note: '注：%单位适用于DCCT标准，mmol/mol单位适用于IFCC标准。',
    DOB: 'DOB',
    SN: 'SN'
  },
  // 字段
  field: {
    timeCgmActive: 'CGM活跃率',
    gmi: '糖尿病管理指数',
    gri: '血糖风险指数',
    eHbA1c: '预估糖化血红蛋白',
    avgPerDay: '平均每日校准次数',
    glucoseAbility: '血糖变异指数',
    lage: '最大血糖波动幅度',
    mage: '平均血糖波动幅度',
    tar: '偏高',
    tbr: '偏低',
    calibrations: '校准次数'
  },
  agp: {
    agpTitle: '动态葡萄糖图谱（AGP）',
    centerLine: '中位线',
    areaLine: '区间',
    target: '目标范围'
  },
  basic: {
    customTir: '自定义TIR',
    bloodTip: '葡萄糖提醒设置',
    bloodUnit: '葡萄糖单位',
    highTip: '高血糖提醒',
    lowTip: '低血糖提醒',
    unitText: '根据国家区域自动设置',
    selectTip: '点击图标以选择或取消相应日期',
    selectAll: '选择全部'
  },
  report: {
    threeMonth: '近3个月',
    sixMonth: '近6个月',
    yearText: '近1年',
    showAll: '显示全部',
    all: '全部',
    selectDate: '选择日期范围',
    to: '至',
    startDt: '开始日期',
    endDt: '结束日期',
    betaTest: 'Beta测试',
    bloodData: '葡萄糖数据',
    userCount: '用户账号'
  },
  petDetail: {
    variety: '品种',
    type: '胰岛素类型',
    freq: '胰岛素使用频率',
    lente: '长效胰岛素',
    insulin: '甘精胰岛素',
    pzi: '精蛋白锌胰岛素',
    nph: '中效胰岛素',
    detemir: '地特胰岛素'
  },
  pdfReport: {
    title: '持续葡萄糖监测评估报告',
    snNumber: '设备编号',
    page: '页码',
    createTime: '生成日期',
    petInfo: '宠物信息',
    petName: '宠物名',
    birthday: '出生年月',
    freq: '胰岛素使用频率',
    petType: '宠物类型',
    age: '年龄',
    registerType: '注册器类型',
    basicBloodData: '基本血糖数据',
    dbText: '葡萄糖目标范围内时间达标率（TIR）',
    target: '适用于1型和2型糖尿病管理目标',
    recordTime: '记录时间',
    tag: '标识',
    event: '事件',
    eventDetail: '事件详情',
    mulityText: '多日葡萄糖趋势图谱',
    mulitySubText: '多日葡萄糖图谱代表一个设备轮次的时间区间',
    avageBlood: '平均葡萄水平',
    bloodText: '日间血糖平均绝对值差',
    highTip: '高血糖提醒',
    lowTip: '低血糖提醒',
    cat: '猫',
    dog: '狗',
    country: '国家',
    insulinDose: '胰岛素剂量',
    weightUnit: '千克'
  },
  // eventDetail for zh.js
  eventDetail: {
    Empty: '空腹',
    After_Breakfast: '早餐后',
    Before_Lunch: '午餐前',
    Breakfast: '早餐',
    Lunch: '午餐',
    Dinner: '晚餐',
    Before_Sleep: '睡前',
    Extra: '加餐',
    Short_acting: '短效',
    Pre_mixed: '混合',
    Long_acting: '长效',
    Middle_acting: '中效',
    hour: '小时',
    minutes: '分钟'
  }
};
export default cn;
